<template>
  <span
    v-if="svgIcon"
    :class="[
      {
        'bg-white-grey': active && !disabled,
        'cursor-pointer hover:bg-white-grey': clickable && !disabled,
        'cursor-not-allowed opacity-50': disabled,
      },
      'inline-flex items-center content-center rounded-24 svg-icon',
      iconClass,
    ]"
    :style="svgIconStyle"
    @click="onClick"
    v-html="svgIcon"
  ></span>
</template>

<script>
import { getSVGIcons } from '~/global/icons/svg-icon'
export default {
  name: 'BaseIconSVG',
  props: {
    name: {
      type: String,
      required: true,
      default() {
        return ''
      },
    },
    color: {
      type: String,
      default() {
        return ''
      },
    },
    width: {
      type: [Number, String],
      default() {
        return -1
      },
    },
    height: {
      type: [Number, String],
      default() {
        return -1
      },
    },
    iconStyle: {
      type: Object,
      default() {
        return {}
      },
    },
    text: {
      type: String,
      default() {
        return ''
      },
    },
    iconClass: {
      type: String,
      default() {
        return ''
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    clickable: {
      type: Boolean,
      default() {
        return false
      },
    },
    active: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  computed: {
    svgIcon() {
      const { color, name, text, size } = this
      const icon = getSVGIcons(name, color, text, undefined, size)
      return icon || null
    },
    svgIconStyle() {
      const { width, height, iconStyle } = this
      const svgIconStyle = Object.assign({}, iconStyle)

      if (+width > 0) {
        svgIconStyle.width = width + 'px'
        svgIconStyle.minWidth = width + 'px'
      }
      if (+height > 0) {
        svgIconStyle.height = height + 'px'
        svgIconStyle.minHeight = height + 'px'
      }
      return svgIconStyle
    },
    sizeClass() {
      return `w-[${this.size}px] h-[${this.size}px] overflow-hidden`
    },
  },
  methods: {
    onClick(e) {
      if (!this.disabled) this.$emit('click', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-icon {
  &.icon-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
